import { createFileRoute, Outlet } from "@tanstack/react-router"
import { AnimatePresence, motion } from "motion/react"

import { generateMetaTags } from "@repo/seo/generate-meta-tags"
import { AuroraBackground } from "@repo/ui/components/ui/aurora-background"
import { sharedConfig } from "~/lib/config/shared"

export const Route = createFileRoute("/_auth-layout")({
  component: AuthLayout,
  head: ({ match }) => ({
    meta: generateMetaTags({
      robots: ["noindex", "nofollow", "noarchive"],
      base: {
        title: `${sharedConfig.appName}`,
        description: `Central Management System for ${sharedConfig.appName}`,
        url: new URL(match.fullPath, sharedConfig.baseUrl).toString(),
      },
    }),
  }),
})

function AuthLayout() {
  return (
    <AnimatePresence mode="wait">
      <AuroraBackground>
        <motion.div
          className="relative z-10 flex w-full max-w-md flex-col items-center justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div
            className="relative w-full"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{
              type: "spring",
              stiffness: 100,
              damping: 15,
            }}
          >
            <div className="mx-4 md:mx-0">
              <Outlet />
            </div>
          </motion.div>
        </motion.div>
      </AuroraBackground>
    </AnimatePresence>
  )
}
